const bloodTypes = ['A+', 'A-', 'AB+', 'AB-', 'B+', 'B-', 'O+', 'O-'];

export const BLOOD_TYPE_OPTIONS = bloodTypes.map((type) => ({
  k: type,
  v: type,
}));
